import {
  fetchMentorClassTaskFilters,
  fetchMentorClassTasks,
} from "classroom/api/teacher";
import { createClassroomTaskListStore } from "portfolio/stores/teacher/createClassroomTaskListStore";

export const useClassroomMentorClassTaskStore = createClassroomTaskListStore(
  "classroomMentorClassTask",
  {
    fetchList: (params, mentorClass) =>
      fetchMentorClassTasks(mentorClass, params),
    fetchFilters: (mentorClass) => fetchMentorClassTaskFilters(mentorClass),
  },
);
